export const banners = {
  name: 'Banner |||| Banners',
  fields: {
    id: 'ID',
    title: 'Title',
    subtitle: 'Subtitle',
    displayType: 'Display Type',
    imageUrl: 'Image URL',
    image: 'Image',
    gradientTheme: 'Gradient Theme',
    gradientStartColor: 'Gradient Start Color',
    gradientEndColor: 'Gradient End Color',
    gradientAngle: 'Gradient Angle',
    iconName: 'Icon Name',
    iconColor: 'Icon Color',
    actionType: 'Action Type',
    actionTarget: 'Action Target',
    actionLabel: 'Action Button Label',
    promotionContent: 'Promotion Content',
    modalButtonText: 'Modal Button Text',
    modalButtonAction: 'Modal Button Action',
    modalButtonActionType: 'Modal Button Action Type',
    modalButtonActionTarget: 'Modal Button Target',
    targetType: 'Target Type',
    targetMembershipLevels: 'Target Membership Levels',
    targetUsers: 'Target Users',
    isActive: 'Is Active',
    validFrom: 'Valid From',
    validUntil: 'Valid Until',
    position: 'Position',
    displayFrequency: 'Display Frequency',
    maxImpressions: 'Max Impressions per User',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    impressions: 'Impressions',
    clicks: 'Clicks',
    ctr: 'Click-through Rate',
    uniqueUsers: 'Unique Users',
    status: 'Status',
    analytics: 'Analytics',
    validity: 'Validity',
    targeting: 'Targeting',
    sendPushOnPublish: 'Send push notification when banner is published',
    pushTitle: 'Push Notification Title',
    pushBody: 'Push Notification Body'
  },
  statistics: 'Statistics',
  statuses: {
    active: 'Active',
    inactive: 'Inactive',
    scheduled: 'Scheduled',
    expired: 'Expired'
  },
  filters: {
    search: 'Search',
    status: 'Status',
    displayType: 'Display Type',
    targetType: 'Target Type',
    createdAfter: 'Created After',
    createdBefore: 'Created Before'
  },
  displayTypes: {
    image: 'Image Banner',
    gradient: 'Gradient Banner'
  },
  actionTypes: {
    none: 'No Action',
    promotionModal: 'Promotion Modal',
    screen: 'Navigate to Screen',
    url: 'Open URL',
    deeplink: 'Deep Link'
  },
  targetTypes: {
    all: 'All Users',
    membership: 'By Membership Level',
    users: 'Specific Users',
    newUsers: 'New Users Only'
  },
  frequencies: {
    always: 'Always Show',
    once: 'Show Once',
    daily: 'Once Per Day',
    weekly: 'Once Per Week'
  },
  memberships: {
    standard: 'Standard',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    vip: 'VIP'
  },
  sections: {
    basicInfo: 'Basic Information',
    action: 'Action Configuration',
    modalButton: 'Modal Button Settings',
    targeting: 'Targeting Rules',
    schedule: 'Schedule & Display',
    translations: 'Multi-language Translations',
    analytics: 'Analytics & Performance',
    bannerContent: 'Banner Content',
    modalContent: 'Promotion Modal Content',
    pushNotification: 'Push Notification'
  },
  tabs: {
    content: 'Content',
    targeting: 'Targeting',
    schedule: 'Schedule',
    translations: 'Translations',
    analytics: 'Analytics'
  },
  create: {
    title: 'Create New Banner',
    subtitle: 'Create a new promotional banner for your app',
    backToList: 'Back to Banners',
    createHint: 'Create promotional banners to engage your app users with targeted content and offers.'
  },
  edit: {
    title: 'Edit Banner',
    subtitle: 'Edit banner details and settings',
    backToList: 'Back to Banners'
  },
  preview: {
    title: 'Banner Preview',
    mobilePreview: 'Mobile Preview',
    enterContent: 'Enter title and subtitle to see preview'
  },
  upload: {
    dragAndDrop: 'Drag & drop image here',
    dropHere: 'Drop image here',
    selectFile: 'Select File',
    supportedFormats: 'PNG, JPG, JPEG, WebP up to 5MB',
    requirements: 'Recommended size: 800x400px (2:1 aspect ratio)',
    uploading: 'Uploading image...',
    imageUploaded: 'Image uploaded successfully',
    fileTooLarge: 'File too large. Maximum size is %{size}',
    invalidFileType: 'Invalid file type. Please upload an image file.',
    uploadError: 'Failed to upload image. Please try again.',
    aspectRatio: 'Best displayed at 2:1 aspect ratio'
  },
  analytics: {
    title: 'Banner Analytics',
    period: 'Period',
    totalImpressions: 'Total Impressions',
    totalClicks: 'Total Clicks',
    conversionRate: 'Click-through Rate',
    uniqueUsers: 'Unique Users',
    dailyTrend: 'Daily Performance Trend',
    deviceBreakdown: 'Device Breakdown',
    engagement: 'Engagement Statistics',
    impressionsDesc: 'Number of times the banner was displayed',
    clicksDesc: 'Number of times users clicked on the banner',
    conversionDesc: 'Percentage of impressions that resulted in clicks',
    usersDesc: 'Number of unique users who saw the banner',
    noData: 'No analytics data available for this banner',
    noDeviceData: 'No device breakdown data available'
  },
  helpers: {
    iconName: 'Enter icon name (e.g., gift, star, lightning-bolt)',
    position: 'Lower numbers appear first (0 = top priority)',
    maxImpressions: 'Leave empty for unlimited impressions',
    screenName: 'Enter the app screen name to navigate to',
    url: 'Enter the full URL to open',
    deeplink: 'Enter the app deeplink URL',
    modalButtonText: 'Text displayed on the button (leave empty to hide button entirely)',
    subtitleGradientOnly: 'Subtitle is only displayed for gradient banners',
    selectIcon: 'Click to select an icon',
    pushTitle: 'Title shown in the push notification (defaults to banner title)',
    pushBody: 'Body text shown in the push notification',
    pushNotificationPreview: 'Push Notification Preview'
  },
  iconPicker: {
    title: 'Select an Icon',
    searchPlaceholder: 'Search icons...'
  },
  notifications: {
    updated: 'Banner updated successfully',
    updateError: 'Failed to update banner',
    created: 'Banner created successfully',
    createError: 'Failed to create banner',
    deleted: 'Banner deleted successfully',
    deleteError: 'Failed to delete banner'
  },
  actions: {
    resendPushNotification: 'Resend Push Notification'
  },
  validation: {
    titleRequired: 'Title is required',
    displayTypeRequired: 'Display type is required',
    imageRequired: 'Image is required for image banners',
    invalidUrl: 'Please enter a valid URL',
    invalidColor: 'Please enter a valid hex color',
    positionMustBeNumber: 'Position must be a number'
  },
  multilang: {
    title: 'Multi-language Translations',
    helperText: 'Provide translations for your banner in different languages. English is required, other languages are optional.',
    copyFromBasic: 'Copy from main text',
    translateFromSimplified: 'Translate from Simplified',
    translateFromTraditional: 'Translate from Traditional',
    titleHelperText: 'The banner title shown to users',
    subtitleHelperText: 'Optional subtitle text for additional context',
    actionLabelHelperText: 'Text for the action button (e.g., "Learn More", "Shop Now")',
    modalButtonTextHelperText: 'Text for the button shown in promotion modal',
    promotionContentHelperText: 'Content shown in promotion modal (if action type is promotion)',
    promotionHelperText: 'Content shown in promotion modal (if action type is promotion)',
    nonEnglishNote: 'Non-English translations are optional. If not provided, the English version will be used.'
  }
};